import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import HomePage from "./Page/HomePage";
import PrivacyPolicy from "./Page/PrivacyPolicy";
import TermsAndConditions from "./Page/TermsAndConditions";
import { useEffect, useState } from "react";
import axios from "axios";

const App = () => {
  const [data, setData] = useState({});

  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);

        const urls = [
          "https://admin.areax.ai/api/projectw?populate=*",
          "https://admin.areax.ai/api/projectw-term-and-condition?populate=*",
          "https://admin.areax.ai/api/projectw-privacy-and-policy?populate=*",
        ];

        const responses = await Promise.all(urls.map((url) => axios.get(url)));

        const [projectwData, termsData, privacyData] = responses.map((res) => res.data?.data);

        // Combine or handle separately as per your need

        setData({
          projectw: projectwData,
          termsAndConditions: termsData,
          privacypolicy: privacyData,
        });
      } catch (err) {
        console.error(err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  return (
    <>
      <Router>
        <Routes>
          <Route path="*" element={<Navigate to="/" />} />
          <Route path="/" element={<HomePage data={data?.projectw} loading={loading} />}></Route>
          <Route path="/privacy-policy" element={<PrivacyPolicy data={data?.projectw} loading={loading} privacyData={data?.privacypolicy} />}></Route>
          <Route path="/terms-conditions" element={<TermsAndConditions data={data?.projectw} loading={loading} termsData={data?.termsAndConditions} />}></Route>
        </Routes>
      </Router>
    </>
  );
};

export default App;
